export const usaStatesAndTerritories = [
    { long: 'Alabama', short: 'AL' },
    { long: 'Alaska', short: 'AK' },
    { long: 'Arizona', short: 'AZ' },
    { long: 'Arkansas', short: 'AR' },
    { long: 'California', short: 'CA' },
    { long: 'Colorado', short: 'CO' },
    { long: 'Connecticut', short: 'CT' },
    { long: 'Delaware', short: 'DE' },
    { long: 'Florida', short: 'FL' },
    { long: 'Georgia', short: 'GA' },
    { long: 'Hawaii', short: 'HI' },
    { long: 'Idaho', short: 'ID' },
    { long: 'Illinois', short: 'IL' },
    { long: 'Indiana', short: 'IN' },
    { long: 'Iowa', short: 'IA' },
    { long: 'Kansas', short: 'KS' },
    { long: 'Kentucky', short: 'KY' },
    { long: 'Louisiana', short: 'LA' },
    { long: 'Maine', short: 'ME' },
    { long: 'Maryland', short: 'MD' },
    { long: 'Massachusetts', short: 'MA' },
    { long: 'Michigan', short: 'MI' },
    { long: 'Minnesota', short: 'MN' },
    { long: 'Mississippi', short: 'MS' },
    { long: 'Missouri', short: 'MO' },
    { long: 'Montana', short: 'MT' },
    { long: 'Nebraska', short: 'NE' },
    { long: 'Nevada', short: 'NV' },
    { long: 'New Hampshire', short: 'NH' },
    { long: 'New Jersey', short: 'NJ' },
    { long: 'New Mexico', short: 'NM' },
    { long: 'New York', short: 'NY' },
    { long: 'North Carolina', short: 'NC' },
    { long: 'North Dakota', short: 'ND' },
    { long: 'Ohio', short: 'OH' },
    { long: 'Oklahoma', short: 'OK' },
    { long: 'Oregon', short: 'OR' },
    { long: 'Pennsylvania', short: 'PA' },
    { long: 'Rhode Island', short: 'RI' },
    { long: 'South Carolina', short: 'SC' },
    { long: 'South Dakota', short: 'SD' },
    { long: 'Tennessee', short: 'TN' },
    { long: 'Texas', short: 'TX' },
    { long: 'Utah', short: 'UT' },
    { long: 'Vermont', short: 'VT' },
    { long: 'Virginia', short: 'VA' },
    { long: 'Washington', short: 'WA' },
    { long: 'West Virginia', short: 'WV' },
    { long: 'Wisconsin', short: 'WI' },
    { long: 'Wyoming', short: 'WY' },
    { long: 'American Samoa', short: 'AS' },
    { long: 'Guam', short: 'GU' },
    { long: 'Northern Mariana Islands', short: 'MP' },
    { long: 'Puerto Rico', short: 'PR' },
    { long: 'United States Virgin Islands', short: 'VI' },
    { long: 'District of Columbia', short: 'DC' },
];

export const canadaProvinces = [
    { long: 'Alberta', short: 'AB' },
    { long: 'British Columbia', short: 'BC' },
    { long: 'Manitoba', short: 'MB' },
    { long: 'New Brunswick', short: 'NB' },
    { long: 'Newfoundland and Labrador', short: 'NL' },
    { long: 'Nova Scotia', short: 'NS' },
    { long: 'Ontario', short: 'ON' },
    { long: 'Prince Edward Island', short: 'PE' },
    { long: 'Quebec', short: 'QC' },
    { long: 'Saskatchewan', short: 'SK' },
    { long: 'Northwest Territories', short: 'NT' },
    { long: 'Nunavut', short: 'NU' },
    { long: 'Yukon', short: 'YT' },
];

export function checkZip(value) {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
}

// This function is used to convert the full name of a province or state to its abbreviation.
// for example, 'British Columbia' -> 'BC'
// If country is not US or Canada, it will return the original name.
export function shortProvinceOrStateName(longName: string) {
    for (const state of usaStatesAndTerritories) {
        if (state.long === longName) {
            return state.short;
        }
    }
    for (const province of canadaProvinces) {
        if (province.long === longName) {
            return province.short;
        }
    }
    return longName;
}

// get country code from country name for most common countries
export function CountryNameToCode(country: string) {
    switch (country) {
        case 'United States':
        case 'USA':
        case 'U.S.A.':
            return 'US';

        case 'Canada':
            return 'CA';

        case 'United Kingdom':
            return 'GB';

        default:
            return country;
    }
}
